<template>
	<div>
		<AppTextTooltip
			tooltipText="Critical errors happen when our engine is unable to process a request.<br />
		Our team gets notified about these errors automatically (without any of your data) so we can fix them. Reach out to support if you need help. "
		>
			<div class="critical-error">Critical error</div>
		</AppTextTooltip>
	</div>
</template>

<script>
export default {
	name: 'CriticalErrorIndicator',
};
</script>

<style scoped lang="scss">
.critical-error {
	width: 80px;
	height: 22px;
	border-radius: 4px;
	border: 1px solid transparent;
	box-sizing: border-box;
	transition: all 0.2s 2s;
	line-height: 19px;
	text-align: center;
	font-size: 11px;
	background: #ffe3ed;
	color: #e95454;
}
</style>
